/**
 * Utility cung cấp các hàm ghi log cho ứng dụng
 * Giúp quản lý log một cách nhất quán và dễ dàng điều chỉnh mức độ log
 */

// Kiểm tra xem đang ở môi trường nào
const isDevelopment = process.env.NODE_ENV === 'development';
const LOG_LEVEL = process.env.LOG_LEVEL || 'info';

// Xác định các mức độ log
const LOG_LEVELS = {
  error: 0,
  warn: 1,
  info: 2,
  debug: 3
};

// Kiểm tra xem có nên log hay không dựa vào mức độ log
const shouldLog = (level: string): boolean => {
  const configuredLevel = LOG_LEVELS[LOG_LEVEL as keyof typeof LOG_LEVELS] || LOG_LEVELS.info;
  const currentLevel = LOG_LEVELS[level as keyof typeof LOG_LEVELS] || 0;
  return currentLevel <= configuredLevel;
};

// Lấy thời gian hiện tại để thêm vào log
const getTimestamp = (): string => {
  const now = new Date();
  return now.toLocaleTimeString();
};

// Tạo logger object
export const logger = {
  debug: (message: string, ...args: any[]): void => {
    if (isDevelopment && shouldLog('debug')) {
      console.log(`[${getTimestamp()}] [DEBUG] ${message}`, ...args);
    }
  },
  
  info: (message: string, ...args: any[]): void => {
    if (shouldLog('info')) {
      console.log(`[${getTimestamp()}] [INFO] ${message}`, ...args);
    }
  },
  
  warn: (message: string, ...args: any[]): void => {
    if (shouldLog('warn')) {
      console.warn(`[${getTimestamp()}] [WARN] ${message}`, ...args);
    }
  },
  
  error: (message: string, ...args: any[]): void => {
    console.error(`[${getTimestamp()}] [ERROR] ${message}`, ...args);
  }
}; 